var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 86,
    viewBox: "0 0 80 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.125977 14.9741L39.1155 1.08826L79.155 14.7272L72.672 66.29L39.1155 84.8662L6.08405 66.5369L0.125977 14.9741Z",
    fill: "#ACABE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1548 14.7272L39.1152 1.08826V84.8662L72.6717 66.321L79.1548 14.7272V14.7272Z",
    fill: "#B4B3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1768 10.8701L14.8818 64.9015L23.9576 64.7473L28.8354 52.5584H50.63L55.9707 64.9015L64.6452 65.0558L39.1768 10.8701ZM39.2388 28.1812L47.4503 45.3377H32.0148L39.2388 28.1812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.3397,
    height: 84.26,
    fill: "white",
    transform: "translate(0.09375 0.872314)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.ccf2894b39f944b0a6f0152520248cb1.svg";
export { ForwardRef as ReactComponent };